import { SerializedFieldContext } from '../../content-control-to-field-map.service';
import { PasteLocation } from '../paste-location';
import { IPasteRule } from './ipasterule';

export class PasteDeniedRule implements IPasteRule {
  private static _instance = new PasteDeniedRule();
  private constructor() {}
  public static get INSTANCE(): PasteDeniedRule {
    return this._instance;
  }
  canPaste(_pasteLocation: PasteLocation, _pasteField: SerializedFieldContext): boolean {
    return false;
  }
}
